module.exports = __webpack_public_path__ + "img/place-of-worship.95d45325.svg";